import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';
import { CrossDeviceAuthData } from './types';
import { Palette } from 'Palette';

interface QRDisplayProps {
  authData: CrossDeviceAuthData;
  timeLeft: number;
}

export function QRDisplay({ authData, timeLeft }: QRDisplayProps) {
  const formatTimeLeft = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  const qrDataString = JSON.stringify(authData.qrData);

  if (process.env.NODE_ENV === 'development') {
    console.log('[QRDisplay] Auth data:', authData);
    console.log('[QRDisplay] QR data:', authData.qrData);
  }

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
      <Typography variant="h6" gutterBottom>
        Scan with Fides Capital App
      </Typography>

      <Box
        sx={{
          p: 2,
          bgcolor: 'white',
          borderRadius: 2,
          border: `1px solid ${Palette.default.border}`,
          boxShadow: 1,
        }}
      >
        <QRCodeSVG
          value={qrDataString}
          size={200}
          bgColor="#ffffff"
          fgColor={Palette.default.text}
          level="M"
        />
      </Box>

      <Typography variant="body2" color="text.secondary" textAlign="center">
        Open the Fides Capital mobile app and scan this QR code to sign in
      </Typography>

      <Chip
        label={`Expires in ${formatTimeLeft(timeLeft)}`}
        size="small"
        color={timeLeft < 60 ? 'error' : 'default'}
      />
    </Box>
  );
}

export default QRDisplay;
